import { getIsIntegrationChannelsMetadataSupported } from '@modules/integrationsV2/utils';
import {
  IntegrationChannelType,
  IntegrationViewFragment,
} from 'generated/graphql';

export const getIntegrationChannelsMetadata = (
  channelType: IntegrationChannelType,
  integrationData: IntegrationViewFragment['data'],
) => {
  const isSupported = getIsIntegrationChannelsMetadataSupported(channelType);
  if (!isSupported) {
    return null;
  }

  switch (channelType) {
    case IntegrationChannelType.Slack:
      return integrationData.slack?.subscribedChannels ?? [];
    case IntegrationChannelType.Discord:
      return integrationData.discord?.subscribedChannels ?? [];
    case IntegrationChannelType.Discourse:
      return integrationData.discourse?.subscribedCategories ?? [];
    case IntegrationChannelType.Typeform:
      return (
        integrationData.typeform?.includedForms?.map((form) => ({
          id: form.id,
          name: form.title,
        })) ?? []
      );
    case IntegrationChannelType.SurveyMonkey:
      return (
        integrationData.surveyMonkey?.includedSurveys?.map((survey) => ({
          id: survey.surveyID,
          name: survey.name,
        })) ?? []
      );
    case IntegrationChannelType.Qualtrics:
      return integrationData.qualtrics?.surveys ?? [];
    default:
      return null;
  }
};
